import { FormElement } from "@src/Components/Common"
import { Button } from "@zeguro/component-library"
import styled from "styled-components"

export const ResetPasswordButton = styled(Button)`
  width: 100%;
  max-width: 472px;
`

export const FormElementStyled = styled(FormElement)`
  width: 100%;
  max-width: 472px;
`
